





















import moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { dateFormat } from '@/data';
import EmploymentTagVue from '@/components/EmploymentTag.vue';
import ExpandVue from '@/components/Expand.vue';
import { IEmployment, IMomentRange } from '@/@types';

const employmentModule = namespace('employment');
const personaModule = namespace('persona');

@Component({
  components: {
    EmploymentTagVue,
    ExpandVue,
  },
})
export default class EmploymentItem extends Vue {
  @Prop({required: true}) public employment!: IEmployment;

  @employmentModule.State('activeTags') public activeTags!: string[];
  @employmentModule.Getter('hasFilters') public hasFilters!: boolean;
  @personaModule.Getter('hasActivePersona') public hasActivePersona!: boolean;

  public monthsBetweenDates(dateSet: IMomentRange): number {
    const diff = Math.floor(moment.duration(dateSet[1].diff(dateSet[0])).as('months'));
    return diff;
  }

  get formattedDates(): string {
    let months = 0;
    this.employment.dates.forEach( (startEnd: IMomentRange) => {
      months += this.monthsBetweenDates( startEnd );
    });

    let datesString = '';
    this.employment.dates.forEach((startEnd: IMomentRange, index: number) => {
      if (this.employment.dates.length > 1 && (index) < this.employment.dates.length && index > 0) {
        datesString += ', ';
      }
      datesString += `${startEnd[0].format(dateFormat)} - ${startEnd[1].format(dateFormat)}`;
    });

    const years = months >= 12 ? Math.floor(months / 12) : 0;
    const remainingMonths = months - (years * 12);
    let totalString = years ? `${years} year${years > 1 ? 's' : ''}` : '';
    totalString += years && remainingMonths ? ', ' : '';
    totalString += remainingMonths ? `${remainingMonths} months` : '';

    return `${datesString} (${totalString})`;
  }

  get includesActiveTags(): boolean {
    return this.tagsInActiveTags.length > 0;
  }

  get tags(): string[] {
    return this.includesActiveTags ? this.tagsInActiveTags : this.sortedTags;
    // return this.includesActiveTags ? this.hasActivePersona ? this.activeTagsFirst : this.tagsInActiveTags : this.sortedTags;
  }

  get sortedTags(): string[] {
    return this.employment.tags.sort() || [];
  }

  get tagsInActiveTags(): string[] {
    return this.activeTags.filter((t: string) => this.sortedTags.includes(t)).sort();
  }

  get activeTagsFirst(): string[] {
    const leftover = this.sortedTags.filter((t: string) => !this.tagsInActiveTags.includes(t));
    return this.tagsInActiveTags.concat(leftover);
  }
}
